export const CODE_LENGTH = 4;
export const DEFAULT_COUNTDOWN_NUMBER = 60;
export const MOBILE_ERROR_TEXT = '手机号无效，请重试';
export const CODE_ERROR_TEXT = '验证码错误';
